import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'
import { PageTitle, Slideshow } from '../../components'
import s1 from './assets/s.1.jpg'
import s2 from './assets/s.2.jpg'
import s3 from './assets/s.3.jpg'
import s4 from './assets/s.4.jpg'
import s5 from './assets/s.5.jpg'
import s6 from './assets/s.6.jpg'
const slideShowData = [s1, s2, s3, s4, s5, s6].map(function(slide, index){
    return {image: slide, text: "ПЪРВА ХАРИТОНОВА ПРЕПРАВКА | НА „ИСТОРИЯ СЛАВЯНОБЪЛГАРСКА“ (ЗМЕЕВО, 1831)"}
})
const HaritonovaPrepravka1View = () => {
    return (
        <MainLayout>
             <Slideshow id="purva-haritonova-prepravka" slides={slideShowData} />
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                <p>
                    <strong>Название на ръкописа</strong>: <strong>Първа Харитонова преправка на „История славянобългарска"</strong>
                    <strong>(Змеево, 1831)</strong>, кратко название <strong>Първа Харитонова преправка (Змеево, 1831)</strong>. В
                    Дигиталния каталог на НБКМ е представена със сигнатура НБКМ 1115 и наименование История славянобългарска (Първа
                    Харитонова, Змеевска преработка).
                </p>
                <p>
                    <strong>Алтернативни названия: </strong>Начовски препис; Втора Змеевска преправка; Първа Харитонова (втора
                    Змеевска) преработка; Втора Змеевска преправка; Харитонова преправка ‒ първа, 1831 г.; Втора змеевска преправка
                    (Харитонова първа); Втора Змеевска преработка на монах Харитон, от 1831; Първи Харитонов (Втори змеевски) препис;
                    Змеевски препис преработка на монах Харитон.
                </p>
                <p>
                    <strong>Година на съставяне: </strong>1831 г. (автентична датировка от преписвача – 10 януари 1831 г.)
                </p>
                <p>
                    <strong>Място на създаване</strong>: Змеево (автентична локализация от преписвача), Старозагорско.
                </p>
                <p>
                    <strong>Преписвач(и</strong>): йеромонах хаджи Харитон Рилец
                </p>
                <p>
                    <strong>Палеографско-кодикологично описание.</strong>
                </p>
                <p>
                    Подвързията е автентична. Тя е от дебел груб картон, подлепен с кафяво-червеникава кожа, която е със значителни
                    разкъсвания в горните и долните ъгли. Хартията е груба, плътна, с хоризонтално линиране.
                </p>
                <p>
                    В левия горен ъгъл на предната корица се вижда каталожният № 1115 на ръкописа от Ръкописния фонд в Националната
                    библиотека „Св. св. Кирил и Методий в София. На няколко места е обозначен и инвентарният № 4/1933. Основният текст
                    е с кафяво-черно мастило, а заглавията и инициалите – с червено.
                </p>
                <p>
                    Ръкописът не е озаглавен. Листовете са изписани от двете страни, но има и празни страници. Оригинална буквена
                    пагинация е нанесена горе вдясно върху лицевата страна на листовете. Тя е различна от допълнително номерираните с
                    арабски цифри 84 листа. Началото на буквената пагинация (͞a) е върху листа с текст <em>За</em> <em>царството
                        българско. Предисловие.</em> Преди този лист има още два. Лицевата част на първия съдържа приписка за
                    родословието на Тачо. Страницата е ръкописно номерирана с цифрата 1. От нея започва последователна цифрова
                    номерация, поставена от някой читател, притежател или тълкувател на Първата Харитонова преправка. По средата в
                    долния край на стр. 1. стои червен печат с текст „Ръкописи на Държавна библиотека „В. Коларов". Същият печат се
                    явява и върху други лицеви страници. Цифровата номерация е само върху лицевата страна на листовете. На гърба на
                    страница 1. (1б) са заглавия, които Харитон е пропуснал да отрази в съдържанието: <em>За Божията Милост</em> и <em>За
                        Преславното чудо на Светителя и</em> <em>великия чудотворец отец Николай, което се случи в Туловското поле край
                        Мъглиж</em>; <em>За Кратката история</em>. Заглавията са придружени с указания за страниците, на които започва
                    текстът на откъсите. Текстовете на съответните страници обаче са без заглавия. Цифровото номериране е
                    последователно от 1 до 73. Със 73 и 74 са отбелязани запазените в ръкописа леви горни ъгли от откъснати листове.
                    Следват още две такива леви горни части без цифрово обозначение. След откъснатите четири листа, от които има само
                    малки части, цифровото обозначаване продължава отново със 73 и е последователно до 80. Следващите листове обаче са
                    неправилно номерирани като л. <strong>84 </strong>(а, б), л. <strong>82 </strong>(а, б), л. <strong>83 </strong>(а,
                    б), л. <strong>84</strong>а (със заглавието и текста <em>За ненавистта</em>), който е и последният означен. На л.
                    84б горе са изписани три реда. Първата част на тези три реда е отпечатана на задната страна на следващия лист.
                    Първата част на отпечатаните три реда се слива с втората част на други три реда от друг текст вероятно поради
                    слепване на страниците.
                </p>
                <p>
                    В Първа Харитонова преправка (Змеево, 1831) буквената пагинация е непоследователна – не всички листове са означени
                    с букви, има и повторения на едно и също буквено означаване – напр. л. ͞нs (58а) и следващия, който също е ͞нs
                    (59а). Задната страна на вторият лист ͞нs (59б) не е изписана, а също и следващата страница (60a) – вероятно са
                    били слепени една с друга. След маркирания с буква ͞s (8a) лист следва лист без буквена пагинация, на който е
                    заглавието [За]<em> прародителя славянобългарски и за неговото племе откъде произлизат е известно</em>. В <em>Оглавлението</em>
                    (<em>Съдържанието</em>) на л. 2а също липсва указание за страницата. След номерирания лист 9 следват още няколко
                    листа без буквено, а само с цифрово означаване. Листовете от 9 до 14 имат двойно цифрово отбелязване Освен
                    последователните цифри, въведени още в началото при приписката за рода на Тачо, се появяват и допълнителни, които
                    започват от 7. Така са номерирани листовете 9/7, 10/8, 11/9, 12/10, 13/11, 14/12. С изключение на л. 14/12, на
                    който е изписана само лицевата страна (14а/12а), останалите листове са изписани двустранно. На л. 11а/9а е
                    заглавието <em>За Илирик, първия български крал.</em> В <em>Оглавлението</em> срещу това заглавие стои <em>Глава ͞</em>г,
                    <em>лист</em> ͞θ. На 12б/10б е заглавието <em>За Болг, Петия български и</em> <em>илирически крал,</em> на 13а/11а
                    – <em>За Лила,</em> <em>Шестия български крал</em>, а на 13б/11б – <em>За Пирун, Седмият български крал</em>.
                    Главите <em>За Болг</em>, <em>За Лила</em> и <em>За</em> <em>Пирун</em> не са посочени в <em>Оглавлението</em>.
                    След описаните шест листа буквената пагинация продължава с ͞гi. Според оригиналната Харитонова буквена пагинация
                    липсват листовете от шестдесет и девети до седемдесет и шести. Частично разкъсани са листовете от шестдесет и
                    девети до седемдесет и втори, а изцяло откъснати са листовете от седемдесет и трети до седемдесет и шести.
                    Последният означен от Харитон лист е ͞пг. На гърба му започва <em>Кратка история за българския род.</em>
                </p>
                <p>
                    <strong>Писмото на ръкописа</strong> е неправилен полуустав. Почеркът показва характерното за Харитон изписване на
                    буквите:<em> д, ч, ь, ъ, ятова гласна, ук </em>и<em> и </em>с надреден знак и надредното краесловно <em>т</em>,
                    отразено по няколко начина.
                </p>
                <p>
                    <strong>Езикът и правописът</strong> са черковнославянски, с поставяни ударения, надредни и разделителни знаци.
                    Годините и числените стойности са отбелязани с букви. Заглавията на историческите дялове се открояват поради
                    изписването им с главни букви. В ръкописа има червенослови: при заглавията (някои с цялостно, други с частично
                    оцветяване); при повечето инициали, с които започват отделните абзаци; върху буквите за обозначаване на години и
                    числени стойности. В цялата книга липсват винетни украси. Независимо от съществуващите задрасквания (например, л.
                    шестнадесети по Харитоновата пагинация; лист тридесет и седми и др.), като цяло ръкописът е изписан старателно.
                </p>
                <p>
                    <strong>Брой листове: </strong>84 листа с размери 160 мм х 210 мм + 2 листа.; липсват л. л. 69 – 76 (частично
                    съхранени са л. л. 69 – 72, изцяло откъснати са л. л. 73 – 76).
                </p>
                <p>
                    <strong>Редове на страница: </strong>21 – 23 реда.
                </p>
                <p>
                    <strong>Размери на листовете: </strong>160 мм х 210 мм.
                </p>
                <p>
                    <strong>Поръчител(и) на ръкописа: </strong>Недялко, Михаил и Стоян<em> </em>– според приписката на Тачо на л. 1а.
                </p>
                <p>
                    <strong>Извод (подложка, антиграф), от който пряко се преписва:</strong> Поп-Йоанова преправка на „История
                    славянобългарска" (Змеево, 1830). Първа Харитонова преправка се отнася се към Група D1 (Димитрова и Пеев 2012).
                </p>
                <p>
                    <strong>Родослов: </strong>Първата Харитонова преправка e пряко свързана със следните ръкописи:
                </p>
                <p>
                    <strong>Рилска преправка → Поп-Йоанова преправка → ПЪРВА ХАРИТОНОВА ПРЕПРАВКА → Втора Харитонова преправка → Геров
                        препис </strong>
                </p>
                <p>
                    <strong>Рилска преправка → Поп-Йоанова преправка → ПЪРВА ХАРИТОНОВА ПРЕПРАВКА → Втора Харитонова преправка →
                        работен препис на Владимир Ламански (Кръстева 2015, 45) </strong>
                </p>
                <p>
                    <strong>Бележките в Първа Харитонова преправка: </strong>
                </p>
                <p>
                    На гърба на листа <em>Оглавлание</em> (<em>Съдържание</em>) (2б) Харитон е написал:
                </p>
                <p>
                    <em>Докато бях <strong>в село Змейово</strong>, аз, монах Харитон, преписах тази История през <strong>1831 Година</strong>
                        от Рождество Христово <strong>в 10-ия ден на Месец януари</strong>.</em>
                </p>
                <p>
                    <em> Тогава в Русия царуваше преславният и великият, най-благочестивият и православен Николай Павлович, който беше
                        одържал славна победа над турците и стигнал чак до Андриан град през изминалата 1829 година на 9 Август. Той
                        сключи мир с турците и се върна заедно със славната си войска обратно през Дунава.</em>
                </p>
                <p>
                    <em> В Цариград пък царуваше султан Махмут, 35-ят турски цар.</em>
                </p>
                <p>
                    <em> А в Мора управляваше княз Каподистрий</em> (превод А. Тошева; отбелязването е мое – АД).
                </p>
                <p>
                    На л. ͞e͞͞͞͞i͞͞͞ б (17б) в горната половина е изписана дума, която може да се разчете като <em>разкайващ се</em>.
                </p>
                <p>
                    На л. ͞мв по Харитон (44б) в лявото поле е изписано с думи <em>до</em> <em>осемдесет и шест </em>(доживял до 86
                    години – бел. АД)<em>, </em>което съответства на отбелязаната в текста числена стойност ͞пs.
                </p>
                <p>
                    На л. ͞мг б (45б) е добавено словосъчетанието: <em>и хитаръ</em>.
                </p>
                <p>
                    <strong>Приписки в ръкописа, оставени от други ръце (на вероятни читатели или притежатели на оригинала):</strong>
                </p>
                <p>
                    В левия горен ъгъл на листа, подлепящ предната корица отвътре, е изписано името <strong><em>Стоян</em>.</strong>
                </p>
                <p>
                    На първия празен лист се четат имената: Нидялку, Михаилъ, Стоени. Под тях се виждат главни и малки букви: <strong>Е,
                        е, а</strong>, <strong>ξ</strong>, от които <strong>ξ</strong> в най-различни варианти. Освен това има неясни
                    думи на различни редове и допълнителен текст с възможен прочит: <em>от моiia за</em> <em>грош: 100:Н:6</em> и на
                    следващия ред: <em>посло</em> [… с? – б. м. А. Д] <em>гроша сто и</em> […].
                </p>
                <p>
                    На гърба на същия лист се четат и още две имена: <strong><em>Тóтю</em></strong> и <strong><em>Слáви</em></strong> и
                    колона от цифри, подредени на отделни редове (22, 60, 300, 200, 100…), с начало горния ляв ъгъл на листа.
                </p>
                <p>
                    На следващия лист, който е без пагинация от Харитон, но номериран с 1 (1a), е дадена информация за рода на Тачо.
                </p>
                <p>
                    <em>Тачо, баща на Стоян, Стоян има син Димитър Стоянов.</em>
                </p>
                <p>
                    <em>Този ръкопис принадлежи на Димитър със стопанка Мария Стоянова. Те имат деца: Мария, Тона, Христаки, Ташина,
                        Бона, Иванчо.</em>
                </p>
                <p>
                    <em> Братята на Димитър са Тачо и Ганю. Тачо живее в Сърбия, а Ганю в Стара Загора.</em>
                </p>
                <p>
                    <em> Стоян, бащата на Димитър, е бил абаджия-сукнар, а не прост шивач на аби.</em>
                </p>
                <p>
                    <em> Тоя ръкопис е оцелял от пожара в <strong>Стара Загора</strong> в къщата на Димитър в една торбичка заедно с
                        други книги, които са се запазили и не са изгорели. След като се върнал от Балкана, той я намерил и я скрил на
                        тавана на къщата си в махала Хакарджа. Тя била затрупа с някои неща и така останала здрава. Дава я на 30 май
                        1892 година. <strong>Недялко, Михаил и Стоян дали пари на Харитон да им го препише</strong> </em>[<em>този
                        ръкопис</em>] (преводът е на А. Тошева; отбелязването е мое – АД).
                </p>
                <p>
                    На листа, подлепящ задната корица от вътрешната страна, е написано <em>февроариа</em> «25» с един почерк, а с друг
                    – част от дума <em>жен</em>, името <em>Тодуръ</em>, инициална буква С, няколко еднакви графични знака и стилизирана
                    рисунка.
                </p>
                <p>
                    <strong>„География" на пътешествията на Първа Харитонова преправка: </strong>
                </p>
                <p>
                    Змеево, Стара Загора – според приписката за рода на Тачо на л.1а.
                </p>
                <p>
                    <strong>Въвеждане на ръкописа в науката</strong>. Първата Харитонова преправка е въведена в науката от Никола Начов
                    през 1894 (Начов 1894) г., когато той публикува студия, озаглавена „Забележка за Паисиевата история". Едни от
                    първите изследователи на ръкописа са М. Дринов (Дринов 1871), В. Златарски (Златарски 1912), Й. Иванов (Иванов
                    1914). Ръкописът е отбелязан в Описа на М. Стоянов (Стоянов 1962). В описа на Христо Кодов и Маньо Стоянов е
                    каталогизиран под № 1115 (Кодов, Стоянов 1964 ІІІ, 452).
                </p>
                <p>
                    <strong>Място на съхранение. </strong>Днес оригиналният ръкопис на Първа Харитонова преправка се съхранява в
                    Ръкописния отдел на Националната библиотека „Св. св. Кирил и Методий" с каталожен № НБКМ 1115 (Кодов, Стоянов 1964
                    III, 452).
                </p>
                <p>
                    <strong>Съвременни издания. </strong>За пръв път оригиналната Първа Харитонова преправка е публикувана през 2015 г.
                    в луксозното издание <strong>Първа Харитонова преправка на „История славянобългарска" (Змеево, 1831). Оригинален
                        текст, превод и изследване. </strong>Мила Кръстева – автор на научното изследване и съставител. Превод от
                    църковнославянски на съвременен български – Атанаска Тошева. Индекс на личните имена, етнонимите и топонимите –
                    Атанаска Тошева. Превод на научното изследване на руски – Атанаска Тошева. Превод на научното изследване на
                    английски: Снежана Цонева<strong>-</strong>Матюсън. Научен консултант по църковнославянски език: Антоанета
                    Джельова. Научен консултант за превода на английски: Джон Матюсън. Научен редактор: Антоанета Джельова
                </p>
                <p>
                    Пловдив, Издателско-полиграфичен комплекс „Жанет-45", 2015. <strong>ISBN 978-</strong>619-186-116-3
                </p>
                <p>

                </p>
                <p> © Гл. ас. д-р Антоанета Джельова</p>


                <p>19.10.2017 г.</p>
                </main>
            </div>
        </MainLayout>
    )
}

HaritonovaPrepravka1View.propTypes = {
    
}

export default HaritonovaPrepravka1View



// WEBPACK FOOTER //
// ./src/views/HaritonovaPrepravka1/index.js